import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as action from '../../redux/actions';
import { Link } from 'react-router-dom';
//  Components
import LoginButton from '../Login/loginButton';
import Logo from '../../img/logo-expo-medica.jpg';
import loginPng from '../../img/login.png';
import Button from '../button';

class ModalLogin extends Component {
   constructor(props) {
      super(props);
      this.state = {
         username: '',
         password: '',
         login_error: '',
      };
      this.login = this.login.bind(this);
   }

   cifrar(texto) {
      const cadena = new Buffer(texto).toString('base64');
      return cadena;
   }

   login(event) {
      event.preventDefault();
      const username = event.target.username.value;
      const password = this.cifrar(event.target.password.value);
      const usuario = { username: username, password: password };
      this.props.dispatch(action.login_user(usuario));
   }

   logOut(event) {
      event.preventDefault();
      if (this.props.auth) {
         this.props.dispatch({ type: 'LOGOUT' });
         this.close();
         window.location = '/inicio';
      }
   }
   handleClick() {
      this.close();
   }

   componentDidUpdate(nextProps) {
      if (this.props.login_error !== nextProps.login_error) {
         this.setState({ login_error: nextProps.login_error });
      }
   }

   close() {
      const modal = document.getElementById('modal-login');
      modal.classList.add('hidden');
      this.setState({ login_error: '' });
   }

   render() {
      return (
         <div className="modal-login hidden" id="modal-login">
            <div className="justify-center">
               <div className="container">
                  <div className="modal-content">
                     <div className="column">
                        <div className="row">
                           <div className="justify-start">
                              <a
                                 id="close-modal-login"
                                 onClick={this.close.bind(this)}
                              >
                                 &times;
                              </a>
                           </div>
                        </div>
                        <div className="login-method row-responsive">
                           <div className="column justify-center align-center">
                              <div className="row justify-center align-center">
                                 <div className="logo-modal responsive-img">
                                    <img src={Logo} alt="Logo Expomédica" />
                                 </div>
                              </div>
                              <div className="row justify-center align-center">
                                 <div className="white-space-16"></div>
                              </div>
                              {this.props.auth ? (
                                 <React.Fragment>
                                    <div className="row justify-center align-center">
                                       <div className="column justify-center align-center">
                                          <h4 className="login-title">
                                             ¡Bienvenido!
                                          </h4>
                                          <h4 className="color-secondary">
                                             {this.props.user.Nombre}
                                          </h4>
                                       </div>
                                    </div>
                                    <div className="row justify-center align-center">
                                       <div className="white-space-16"></div>
                                    </div>
                                    <div className="row justify-center align-center">
                                       <div className="column justify-center align-center">
                                          <Link
                                             className="link"
                                             to="/perfil"
                                             onClick={this.handleClick.bind(
                                                this
                                             )}
                                          >
                                             <h4 className="login-title">
                                                Editar Perfil
                                             </h4>
                                          </Link>
                                       </div>
                                    </div>
                                    <div className="row justify-center align-center">
                                       <div className="white-space-16"></div>
                                    </div>
                                    <div className="row justify-center align-center">
                                       <div className="column justify-center align-center">
                                          <Link
                                             className="link"
                                             to="/carrito"
                                             onClick={this.handleClick.bind(
                                                this
                                             )}
                                          >
                                             <h4 className="login-title">
                                                Carrito
                                             </h4>
                                          </Link>
                                       </div>
                                    </div>
                                    <div className="row justify-center align-center">
                                       <div className="white-space-16"></div>
                                    </div>
                                    <div className="row justify-center align-center">
                                       <div className="column justify-center align-center">
                                          <Link
                                             className="link"
                                             to="/pedidos"
                                             onClick={this.handleClick.bind(
                                                this
                                             )}
                                          >
                                             <h4 className="login-title">
                                                Pedidos
                                             </h4>
                                          </Link>
                                       </div>
                                    </div>
                                    <div className="row justify-center align-center">
                                       <div className="white-space-16"></div>
                                    </div>
                                    <div className="row justify-center align-center">
                                       <div className="column justify-center align-center">
                                          <Link
                                             className="link"
                                             to="/facturas"
                                             onClick={this.handleClick.bind(
                                                this
                                             )}
                                          >
                                             <h4 className="login-title">
                                                Facturas
                                             </h4>
                                          </Link>
                                       </div>
                                    </div>
                                    <div className="row justify-center align-center">
                                       <div className="white-space-16"></div>
                                    </div>
                                    <div className="row align-center justify-center">
                                       <Button
                                          id="btn-logout"
                                          onClick={this.logOut.bind(this)}
                                       >
                                          <i className="fas fa-sign-out-alt"></i>{' '}
                                          &nbsp; Cerrar sesión
                                       </Button>
                                       <p
                                          className="weight-bold"
                                          id="registerLink"
                                       ></p>
                                    </div>
                                 </React.Fragment>
                              ) : (
                                 <React.Fragment>
                                    <div className="row justify-center align-center">
                                       <div className="column justify-center align-center">
                                          <h3 className="login-title quicksand color-secondary">
                                             Iniciar sesión
                                          </h3>
                                       </div>
                                    </div>
                                    <div className="row justify-center align-center">
                                       <div className="white-space-16"></div>
                                    </div>
                                    <div className="row justify-center align-center">
                                       <form
                                          onSubmit={this.login.bind(this)}
                                          className="column"
                                       >
                                          <div className="row-responsive align-center">
                                             <input
                                                className="input-text"
                                                placeholder="Usuario"
                                                type="text"
                                                name="username"
                                                required
                                             />
                                          </div>
                                          <div className="white-space-16"></div>
                                          <div className="row-responsive align-center">
                                             <input
                                                className="input-text"
                                                type="password"
                                                name="password"
                                                placeholder="Contraseña"
                                                onChange={event =>
                                                   this.setState({
                                                      password:
                                                         event.target.value,
                                                   })
                                                }
                                                value={this.state.password}
                                                required
                                             />
                                          </div>
                                          <div className="row">
                                             <div className="white-space-16"></div>
                                          </div>
                                          <p className="color-red weight-medium text-center">
                                             {this.state.login_error}
                                          </p>
                                          <div className="white-space-16" />
                                          <div className="row align-center justify-center">
                                             <LoginButton
                                                login={this.user}
                                                username={this.state.username}
                                                password={this.state.password}
                                             />
                                             <p
                                                className="weight-bold"
                                                id="registerLink"
                                             ></p>
                                          </div>
                                          <div className="white-space-16" />
                                          <div className="column text-center">
                                             <a
                                                id="btn-newAddress"
                                                onClick={() =>
                                                   (window.location =
                                                      '/registro')
                                                }
                                             >
                                                <Button theme="dark">
                                                   Regístrate
                                                </Button>
                                             </a>
                                          </div>
                                          <div className="white-space-16" />
                                          <div className="column text-center forgot-pass">
                                             <Link
                                                className="column"
                                                to="/recuperar"
                                             >
                                                ¿Olvidaste tu contraseña?
                                             </Link>
                                          </div>
                                          <div className="white-space-16" />
                                       </form>
                                    </div>
                                 </React.Fragment>
                              )}
                           </div>
                        </div>
                     </div>
                     <div className="quick-about">
                        <div
                           className="left"
                           style={{
                              backgroundImage: `url(${loginPng})`,
                              marginLeft: '20px',
                           }}
                        />
                     </div>
                  </div>
               </div>
            </div>
         </div>
      );
   }
}

function mapStateToProps(state) {
   return {
      auth: state.auth,
      user: state.user,
      login_error: state.login_error,
   };
}

export default connect(mapStateToProps)(ModalLogin);



// WEBPACK FOOTER //
// ./src/components/Modals/modalLogin.js